import { useTranslation } from 'react-i18next'

const ParkingPaymentProcessing = () => {
  const { t } = useTranslation(['parking'])
  return (
    <div className="loader-container">
      <div className="loader" />
      <div>{t('parking:paymentProcessing')}</div>
    </div>
  )
}

export default ParkingPaymentProcessing
